import React, { useEffect, useState } from "react";
import "./Banner.css";
import { Link } from "react-router-dom";

const slides = [
  {
    image:
      "https://res.cloudinary.com/di82vlbpn/image/upload/v1764967286/Google_AI_Studio_2025-12-05T20_38_55.907Z_iefadd.png",
    title: "Your Trusted Aluminium & Glass Work Professionals",
    
  },
  {
    image:
      "https://res.cloudinary.com/di82vlbpn/image/upload/v1765733890/Google_AI_Studio_2025-12-14T17_37_50.786Z_pgr5yz.png",
    title: "Modern Aluminium & Glass Solutions",
 
  },
  {
    image:
      "https://res.cloudinary.com/di82vlbpn/image/upload/v1764967286/Google_AI_Studio_2025-12-05T20_39_35.931Z_wilzzc.png",
    title: "Premium Aluminium & Glass Work",
   
  },
];

const Banner = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="slider">
      {slides.map((slide, i) => (
        <div
          key={i}
          className={i === index ? "slide active" : "slide"}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          {/* Center Bottom Content */}
          <div className="bottom-center">
            <h2>{slide.title}</h2>
      
           <button> <Link to='/contact' className="bb" >Contact Us</Link></button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Banner;
